import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
//import Cookies from "js-cookie";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import ScrollSmoother from "gsap/ScrollSmoother";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, ScrollSmoother);
import zenscroll from "zenscroll";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;

// loose-canvas text entries carry absolute-px font sizes; --text-scale
// normalises them against this fixed design width so a .grid_loose of any
// width wraps text the same as the CMS editor. Must match NATIVE_LOOSE_WIDTH
// in src/manage_canvas.js and the .textEntry_inner zoom in scss/_layouts.scss.
const NATIVE_LOOSE_WIDTH = 1920;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
let overlayInner, overlayCloser;
if (typeof overlay != "undefined" && overlay != null) {
  overlayInner = overlay.querySelector(".inner");
  overlayCloser = overlay.querySelector(".closeLabel");
}
const searchBtn = document.querySelector(".fixed_searchBtn");
const searchOverlay = document.getElementById("searchOverlay");

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  /* ***************************************** */
  /* SMOOTH SCROLLING (GSAP ScrollSmoother) */
  /* ***************************************** */

  let smoother = null;
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  if (
    document.getElementById("smooth-wrapper") &&
    document.getElementById("smooth-content") &&
    !prefersReducedMotion
  ) {
    smoother = ScrollSmoother.create({
      wrapper: "#smooth-wrapper",
      content: "#smooth-content",
      smooth: 1,
      smoothTouch: 0, // native scrolling on touch devices
      // enable data-speed / data-lag, but ONLY inside the smoothed content –
      // the default selector is document-wide and would double-drive the
      // .background scribbles that backgroundParallaxInit() already handles.
      // Off on phones: the staggered speeds make single-column cells overlap.
      effects: window.matchMedia("(max-width: 767px)").matches
        ? false
        : "#smooth-content [data-speed], #smooth-content [data-lag]",
    });
  }

  // coming soon animation
  function draw() {
    return gsap.fromTo(
      "#reveal",
      { drawSVG: "0%" },
      { drawSVG: "100%", duration: 1.3, ease: "power1.inOut" },
    );
  }

  /*
  function comingSoonIntro() {
    let brandColumn = document.querySelector(".column.brand");
    if (typeof brandColumn == "undefined" || brandColumn == null) {
      return;
    }

    // gsap set initial states
    gsap.set(".column.contacts h1", { opacity: 0 });
    gsap.set(".column.contacts .text", { opacity: 0 });
    gsap.set(".column.contacts", { opacity: 1 });

    let tl = gsap.timeline();

    tl.fromTo(
      ".column.brand .logos",
      { clipPath: "inset(0% 0% 100% 0%)" },
      { clipPath: "inset(0% 0% 0% 0%)", duration: 1, ease: "power2.inOut" },
    )
      .to(".column.contacts h1", {
        opacity: 1,
        duration: 0.6,
        ease: "power1.out",
      })
      .add(draw())
      .to(
        ".column.contacts .text",
        { opacity: 1, duration: 0.8, ease: "power1.out" },
        "+=0.1",
      );
  }
  comingSoonIntro();
  */

  // Everything on the homepage that plays in once the intro overlay is out of
  // the way: logo and headline fade in, the circle draws on, then the grid
  // staggers up. Built paused so the intro can slot it into its own timeline.
  // Only runs alongside the intro - repeat visits skip it.
  function homeRevealTimeline() {
    if (prefersReducedMotion) {
      return null;
    }

    // The .intro block is optional - without it, just the grid plays in.
    let homeIntro = document.querySelector(".intro");

    let introContent =
      homeIntro != null ? homeIntro.querySelectorAll(".logo, .text") : [];

    // The circle's stroked #reveal path is the mask for the solid red artwork,
    // so drawing that stroke on is what wipes the circle in.
    let circle =
      homeIntro != null
        ? homeIntro.querySelector(".text svg.circle #reveal")
        : null;

    let gridItems = document.querySelectorAll(".staggered_rows .cell");

    if (introContent.length == 0 && circle == null && gridItems.length == 0) {
      return null;
    }

    if (introContent.length > 0) {
      gsap.set(introContent, { opacity: 0 });
    }
    if (gridItems.length > 0) {
      gsap.set(gridItems, { opacity: 0, y: 20 });
    }
    if (circle != null) {
      gsap.set(circle, { drawSVG: "0%" });
    }

    let tl = gsap.timeline({ paused: true });

    if (introContent.length > 0) {
      tl.to(introContent, {
        opacity: 1,
        duration: 1,
        stagger: 0.4,
        ease: "power1.out",
      });
    }

    if (circle != null) {
      tl.to(
        circle,
        { drawSVG: "100%", duration: 1.3, ease: "power1.inOut" },
        "-=0.2",
      );
    }

    if (gridItems.length > 0) {
      tl.to(
        gridItems,
        { opacity: 1, y: 0, stagger: 0.35, duration: 0.8, ease: "power1.out" },
        "-=0.5",
      );
    }

    return tl;
  }

  // Once a visitor has seen the intro, index.php leaves it out for 30 days.
  function setIntroSeen() {
    let secure = location.protocol == "https:" ? "; Secure" : "";
    document.cookie =
      "papercut_intro=1; max-age=" +
      60 * 60 * 24 * 30 +
      "; path=/; SameSite=Lax" +
      secure;
  }

  // Plays the intro overlay, then the homepage reveal. Returns a promise that
  // resolves once the intro has started (or straight away when there isn't
  // one), which is what the page's own media waits on - so the intro's assets
  // get the connection to themselves, and the grid loads behind the overlay.
  function introTimeline() {
    let intro = document.getElementById("intro");
    let logos = intro != null ? intro.querySelector(".logos") : null;

    // No intro means a repeat visit (see index.php), so the homepage just shows
    // as rendered - no reveal - to get it on screen as fast as possible.
    if (intro == null || logos == null) {
      return Promise.resolve();
    }

    let reveal = homeRevealTimeline();

    // A shared video link goes straight to the video, so the intro is skipped
    // and the homepage shown as it ends up.
    if (overlayHashKey() != null) {
      setIntroSeen();
      gsap.set(intro, { autoAlpha: 0 });
      if (reveal != null) {
        reveal.progress(1);
      }
      return Promise.resolve();
    }

    //let arrow = intro.querySelector(".arrow");

    if (prefersReducedMotion) {
      setIntroSeen();
      gsap.set(logos, { opacity: 1 });
      //gsap.set(arrow, { opacity: 1 });
      gsap.to(intro, { autoAlpha: 0, duration: 0.5, delay: 1.5 });
      return Promise.resolve();
    }

    // Tuning knobs for the rhythm.
    let revealDuration = 1.4;
    //let arrowDuration = 1;
    let beat = 0.8;

    // Closed from the bottom up, so the wipe reveals the mark top to bottom -
    // the same move as the coming soon page.
    gsap.set(logos, { clipPath: "inset(0% 0% 100% 0%)", opacity: 1 });

    // Held until the logo image is ready, so the reveal never plays over an
    // image that's still loading.
    let tl = gsap.timeline({ paused: true });

    tl.to(logos, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: revealDuration,
      ease: "power2.inOut",
    });

    // Drops in from above and bounces to rest. xPercent keeps the CSS
    // centering now that GSAP owns the transform.
    /*
    tl.fromTo(
      arrow,
      { xPercent: -50, y: -40, opacity: 0 },
      { y: 0, opacity: 1, duration: arrowDuration, ease: "bounce.out" },
    );
	*/

    // Hold on the finished mark, then fade it out as the overlay starts to
    // collapse and uncover the page.
    tl.addLabel("reveal", "+=" + beat);
    tl.call(removeSkip, null, "reveal");
    tl.to([logos], { opacity: 0, duration: 0.6 }, "reveal");
    tl.to(
      intro,
      { height: 0, duration: 1.5, ease: "sine.inOut" },
      "reveal+=0.3",
    );

    // The homepage plays in as the overlay finishes clearing.
    if (reveal != null) {
      tl.add(reveal.paused(false), "-=0.5");
    }

    // Any click, scroll or key press jumps straight to the overlay clearing.
    let skipEvents = ["pointerdown", "wheel", "touchstart", "keydown"];

    function skip() {
      removeSkip();
      if (tl.time() < tl.labels.reveal) {
        tl.play("reveal");
      }
    }

    function removeSkip() {
      skipEvents.forEach((type) => window.removeEventListener(type, skip));
    }

    skipEvents.forEach((type) =>
      window.addEventListener(type, skip, { passive: true }),
    );

    let logoImg = logos.querySelector("img");
    let logoReady =
      logoImg != null && typeof logoImg.decode == "function"
        ? logoImg.decode()
        : Promise.resolve();

    // Play even if the image fails, rather than leave the overlay up.
    return logoReady
      .catch(() => {})
      .then(() => {
        setIntroSeen();
        if (tl.time() == 0) {
          tl.play();
        }
      });
  }
  const introReady = introTimeline();

  function twoColumnTimeline() {
    let brandColumn = document.querySelector(".column.brand");
    if (typeof brandColumn == "undefined" || brandColumn == null) {
      return;
    }

    // gsap set initial states
    gsap.set(".column.contacts .text", { opacity: 0 });
    gsap.set(".column.contacts", { opacity: 1 });

    let tl = gsap.timeline();

    tl.fromTo(
      ".column.brand .logos",
      { clipPath: "inset(0% 0% 100% 0%)" },
      { clipPath: "inset(0% 0% 0% 0%)", duration: 1, ease: "power2.inOut" },
    ).to(
      ".column.contacts .text",
      { opacity: 1, duration: 0.8, ease: "power1.out" },
      ".5",
    );
  }
  twoColumnTimeline();

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  function loadInit() {
    // global animation effects
    ScrollTrigger.batch(".fadeUp", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });

    ScrollTrigger.batch(".fadeOn", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, stagger: 0.1 });
      },
    });

    setTimeout(function () {
      ScrollTrigger.batch(".fadeUpDelay", {
        onEnter: (elements, triggers) => {
          gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
        },
      });
    }, 300);

    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });
  }

  // Held until the intro is playing - see introTimeline().
  introReady.then(loadInit);

  // loose grids

  let looseGrids = document.querySelectorAll(".grid_loose");
  looseGrids.forEach((looseGrid) => {
    let catid = looseGrid.getAttribute("data-catid");
    let grid;
    let view = "desktop";
    let resizeTimeout;

    function checkView() {
      let newView = innerWidth <= 768 ? "mobile" : "desktop";
      if (view !== newView) {
        view = newView;
        return true;
      }
      return false;
    }

    function loadGrid() {
      fetch(`/getCanvas.php?catid=${catid}&view=${view}`)
        .then((response) => response.text())
        .then((data) => {
          looseGrid.innerHTML = data;
          grid = looseGrid.querySelector("ul.canvas");

          // set before first paint so text entries never flash at full px
          // size; updatePositions() keeps it current on every resize after
          looseGrid.style.setProperty(
            "--text-scale",
            grid.getBoundingClientRect().width / NATIVE_LOOSE_WIDTH,
          );

          // only a width change re-lays-out the canvas. updateContainerHeight()
          // sets the grid's own height, so reacting to every resize re-ran
          // the layout off its own output — any item whose measured bottom
          // grew with the canvas (seen on iOS) pushed it taller forever
          let lastWidth = null;
          const resizeObserver = new ResizeObserver((entries) => {
            const width = entries[0].contentRect.width;
            if (width === lastWidth) return;
            lastWidth = width;
            updatePositions();
          });
          resizeObserver.observe(grid);

          loadInit();

          setTimeout(function () {
            updateContainerHeight();
          }, 500);
        })
        .catch((error) => console.error("Error:", error));
    }

    // Initial check and load
    checkView();
    loadGrid();

    // Debounced window resize handler
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (checkView()) {
          loadGrid();
        }
      }, 250); // Wait 250ms after last resize event
    });

    function updatePositions() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      const { width, height } = grid.getBoundingClientRect();

      // keep text-entry px sizes faithful to the CMS at this canvas width
      looseGrid.style.setProperty("--text-scale", width / NATIVE_LOOSE_WIDTH);

      items.forEach((item) => {
        let percentX = parseFloat(item.dataset.x);
        let percentY = parseFloat(item.dataset.y);

        // apply the new positions as pixels
        item.style.left = `${(percentX / 100) * width}px`;
        item.style.top = `${(percentY / 100) * width}px`; // Base top on width

        // clear out transforms from draggable
        gsap.set(item, {
          x: 0,
          y: 0,
          z: 0,
        });
      });

      updateContainerHeight();
    }

    function updateContainerHeight() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      requestAnimationFrame(() => {
        let maxBottom = 0;

        items.forEach((item) => {
          let topPos = gsap.getProperty(item, "top"); // Get the top position in pixels
          itemBottom = topPos + item.offsetHeight; // Distance from top + height
          maxBottom = Math.max(maxBottom, itemBottom);
        });

        grid.style.height = `${Math.ceil(maxBottom)}px`; // Round up & add buffer for admin, on front-end this should be tight to the grid
        grid.style.minHeight = "auto";
      });
    }
  });

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");
  let counterEl = document.querySelector(".counter .current");

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    let flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell",
    });

    // change event
    flkty.on("change", function (index) {
      let slideCount = index + 1;
      counterEl.innerHTML = slideCount;
    });
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  editorsHoverInit();

  colorThemeInit();

  eyeFooterFadeInit();

  headerLogoScrollInit();

  backgroundParallaxInit();

  //bioRevealInit();

  // before the reveal, so the slider's loop copies get its hover too
  slidersInit();

  staggeredRowsRevealInit();

  navMarksInit();

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      videoEl.play();
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      if (typeof videoHold != "undefined" && videoHold != null) {
        videoHold.innerHTML = videoStr;
        videoEl = videoHold.querySelector("video");
        videoEl.play();
      }
    }
    el.classList.add("playing");
  }

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    videoEl.pause();
    el.classList.remove("playing");
  }

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    body.classList.add("overlayOn");
    overlay.classList.add("on");
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    overlayCell = null;
    setOverlayHash(null);
    // a result played from the search leaves the search overlay open behind it
    if (searchOverlay == null || !searchOverlay.classList.contains("on")) {
      body.classList.remove("overlayOn");
    }
    overlayInner.innerHTML = "";
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function editorsHoverInit() {
    // disable on mobile
    if (innerWidth <= 768) {
      return;
    }

    let editorsWrap = document.querySelector(".editors_wrap");
    if (typeof editorsWrap == "undefined" || editorsWrap == null) {
      return;
    }

    let editorsList = editorsWrap.querySelector("ul");
    let editorLinks = editorsWrap.querySelectorAll("ul li a");
    let mediaCells = editorsWrap.querySelectorAll(".media .cell");

    editorLinks.forEach((link) => {
      link.addEventListener("mouseenter", function () {
        let id = link.getAttribute("data-id");
        mediaCells.forEach((cell) => {
          let cellVideo = cell.querySelector("video");
          if (cellVideo) {
            cellVideo.play();
          }
          cell.classList.toggle("active", cell.getAttribute("data-id") === id);
        });
        body.classList.add("editor_active");
      });
    });

    editorsList.addEventListener("mouseleave", function () {
      body.classList.remove("editor_active");
      mediaCells.forEach((cell) => {
        cell.classList.remove("active");
        setTimeout(() => {
          let cellVideo = cell.querySelector("video");
          if (cellVideo) {
            cellVideo.pause();
            cellVideo.currentTime = 0;
            cellVideo.load();
          }
        }, 510); // Delay of 510ms before pausing the video
      });
    });
  }

  /* this function was for revealling bio on screen, switched to overlay bio */
  function bioRevealInit() {
    let bioCells = document.querySelectorAll(".bio_cell");
    if (!bioCells.length) {
      return;
    }

    bioCells.forEach((cell) => {
      let trigger = cell.querySelector(".bio_trigger");
      let contents = cell.querySelector(".bio_contents");
      let inner = contents.querySelector(".bio_inner");
      let gridLower = cell.nextElementSibling;
      if (
        typeof gridLower == "undefined" ||
        gridLower == null ||
        !gridLower.classList.contains("grid_lower")
      ) {
        gridLower = null;
      }

      trigger.addEventListener("click", function () {
        let isOpen = cell.classList.contains("bio_open");
        let innerHeight = inner.offsetHeight;

        gsap.to(contents, {
          height: isOpen ? 0 : innerHeight,
          duration: 0.5,
          ease: "power2.inOut",
        });

        if (gridLower) {
          gsap.to(gridLower, {
            marginTop: isOpen ? 0 : innerHeight,
            duration: 0.5,
            ease: "power2.inOut",
          });
        }

        cell.classList.toggle("bio_open", !isOpen);

        if (isOpen) {
          gsap.to([document.querySelector(".background .scribble-large")], {
            opacity: 1,
            duration: 0.5,
          });
        } else {
          gsap.to([document.querySelector(".background .scribble-large")], {
            opacity: 0,
            duration: 0.5,
          });
        }
      });
    });
  }

  // The circle and underline marks on the nav links draw on each time they're
  // hovered, rather than just fading in. The fade itself stays in CSS, so they
  // still show if this doesn't run. The current page's mark is left drawn.
  //
  // The header nav's marks sit in .header_marks, clear of the header's blend,
  // so hovering a header link sets .hover on its twin there to show the mark.
  function navMarksInit() {
    let markLinks = document.querySelectorAll(".header_marks nav a");

    document.querySelectorAll("header nav a").forEach((link, i) => {
      let markLink = markLinks[i];
      if (markLink == null) {
        return;
      }

      link.addEventListener("mouseenter", () =>
        markLink.classList.add("hover"),
      );
      link.addEventListener("mouseleave", () =>
        markLink.classList.remove("hover"),
      );
      drawOnHover(link, markLink);
    });

    document.querySelectorAll(".fixed.menu a").forEach((link) => {
      drawOnHover(link, link);
    });
  }

  function drawOnHover(link, markLink) {
    if (prefersReducedMotion) {
      return;
    }

    let draw = markLink.querySelector(".nav_mark .draw");
    if (draw == null) {
      return;
    }

    let isCircle = draw.closest(".nav_mark").classList.contains("circle");

    link.addEventListener("mouseenter", function () {
      if (link.classList.contains("pageOn")) {
        return;
      }

      gsap.fromTo(
        draw,
        { drawSVG: "0%" },
        {
          drawSVG: "100%",
          duration: isCircle ? 0.7 : 0.45,
          ease: "power1.inOut",
          overwrite: true,
        },
      );
    });
  }

  // The track scrolls natively, so trackpad / magic mouse swipes and touch
  // just work, and CSS snapping centers each slide. The arrows step one slide
  // either way.
  //
  // It loops: the slides are cloned into a full set either side, and once
  // scrolling settles in a copy the track jumps back to the same slide in the
  // middle set. The copies are identical, so the jump can't be seen.
  function slidersInit() {
    document.querySelectorAll(".slider").forEach((slider) => {
      let track = slider.querySelector(".slider_track");
      let originals = Array.from(track.querySelectorAll(".slide"));
      let prev = slider.querySelector(".slider_arrow.prev");
      let next = slider.querySelector(".slider_arrow.next");
      let count = originals.length;

      if (count == 0) {
        return;
      }

      // one slide - nothing to step through or loop
      if (count == 1) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }

      function cloneSet() {
        let fragment = document.createDocumentFragment();
        originals.forEach((slide) => {
          let clone = slide.cloneNode(true);
          clone.classList.add("slide_clone");
          clone.setAttribute("aria-hidden", "true");
          // the overlay opens (and steps from) the real slide - see
          // loadOverlayItem()
          clone.sliderOriginal = slide;
          fragment.appendChild(clone);
        });
        return fragment;
      }

      track.prepend(cloneSet());
      track.append(cloneSet());

      let slides = Array.from(track.querySelectorAll(".slide"));

      function centerOf(slide) {
        return slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;
      }

      // the slide nearest the middle of the track
      function currentIndex() {
        let middle = track.scrollLeft + track.clientWidth / 2;
        let closest = 0;
        let closestDistance = Infinity;
        slides.forEach((slide, i) => {
          let distance = Math.abs(
            slide.offsetLeft + slide.offsetWidth / 2 - middle,
          );
          if (distance < closestDistance) {
            closest = i;
            closestDistance = distance;
          }
        });
        return closest;
      }

      function goTo(index, instant) {
        let slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
        track.scrollTo({
          left: centerOf(slide),
          behavior: instant || prefersReducedMotion ? "auto" : "smooth",
        });
      }

      // settled in one of the copies - hop to the same slide in the middle set
      function recenter() {
        let index = currentIndex();
        if (index < count) {
          goTo(index + count, true);
        } else if (index >= count * 2) {
          goTo(index - count, true);
        }
      }

      prev.addEventListener("click", () => goTo(currentIndex() - 1));
      next.addEventListener("click", () => goTo(currentIndex() + 1));

      // scrollend where it's supported, otherwise a pause in scroll events -
      // which also waits out trackpad momentum
      if ("onscrollend" in window) {
        track.addEventListener("scrollend", recenter);
      } else {
        let idle = null;
        track.addEventListener(
          "scroll",
          () => {
            clearTimeout(idle);
            idle = setTimeout(recenter, 150);
          },
          { passive: true },
        );
      }

      // open on the second slide
      goTo(count + 1, true);
    });
  }

  function staggeredRowsRevealInit() {
    // disable on mobile
    if (innerWidth <= 768) {
      return;
    }

    let cells = document.querySelectorAll(
      ".grid.staggered_rows .cell, .slider .slide",
    );
    if (!cells.length) {
      return;
    }

    cells.forEach((cell) => {
      let reveal = cell.querySelector(".info .reveal");
      if (typeof reveal == "undefined" || reveal == null) {
        return;
      }

      cell.addEventListener("mouseenter", function () {
        // measure the natural content height while collapsed
        let target = reveal.scrollHeight;

        gsap.to(reveal, {
          height: target,
          opacity: 1,
          duration: 0.5,
          ease: "power2.out",
          overwrite: true,
          // release to auto so later reflow stays correct
          onComplete: () => gsap.set(reveal, { height: "auto" }),
        });
      });

      cell.addEventListener("mouseleave", function () {
        gsap.to(reveal, {
          height: 0,
          opacity: 0,
          duration: 0.4,
          ease: "power2.inOut",
          overwrite: true,
        });
      });
    });
  }

  /* VIDEO OVERLAY - linkable: the open item's slug rides in the URL hash */

  // the hash the overlay put in the URL (or opened from), so closing it only
  // clears its own - any other hash is left alone
  let overlayHash = null;

  // the URL hash without the #, if it could name an item: a slug, or
  // video-123 for the few items without one
  function overlayHashKey() {
    let match = window.location.hash.match(/^#([a-z0-9_@-]+)$/i);
    return match ? match[1] : null;
  }

  function cellHashKey(cell) {
    let slug = cell.getAttribute("data-slug");
    return slug ? slug : "video-" + cell.getAttribute("data-id");
  }

  // replaceState rather than a new history entry - the back button stays with
  // the page loads, which popstate reloads by path
  function setOverlayHash(key) {
    if (
      key == null &&
      (overlayHash == null || overlayHashKey() !== overlayHash)
    ) {
      overlayHash = null;
      return;
    }
    overlayHash = key;
    let url =
      window.location.pathname +
      window.location.search +
      (key != null ? "#" + key : "");
    history.replaceState(history.state, "", url);
  }

  // Opens the item a #slug hash names: from its cell when it's on the page,
  // so the arrows and next cards step through that grid, otherwise on its
  // own - getItem.php looks the slug up and 404s if there's no such item.
  function overlayHashOpen() {
    let key = overlayHashKey();
    if (key == null || typeof overlay == "undefined" || overlay == null) {
      return;
    }
    if (overlayCell != null && cellHashKey(overlayCell) === key) {
      return;
    }

    let cell = Array.prototype.find.call(
      document.querySelectorAll(".openOverlay[data-id]"),
      (item) =>
        !item.classList.contains("textentry") &&
        !item.classList.contains("slide_clone") &&
        cellHashKey(item) === key,
    );

    if (cell == null) {
      cell = document.createElement("div");
      let idMatch = key.match(/^video-(\d+)$/);
      if (idMatch) {
        cell.setAttribute("data-id", idMatch[1]);
      } else {
        cell.setAttribute("data-slug", key);
      }
    }

    loadOverlayItem(cell);
  }

  /* VIDEO OVERLAY - stepping through the grid the item was opened from */

  // the cell whose item the overlay is currently showing
  let overlayCell = null;

  // the other cells you can step to: the openable ones in the same grid, in
  // the order they appear on the page. Text entries aren't playable, so the
  // homepage's copy blocks drop out. The editor grid splits its cells across two
  // columns, so data-order restores the sequence there.
  function overlaySiblings(cell) {
    let group =
      cell.closest(".staggered_rows, .slider, .editor_grid, .search_grid") ||
      document;

    return Array.prototype.filter
      .call(
        group.querySelectorAll(".openOverlay[data-id]"),
        (item) =>
          !item.classList.contains("textentry") &&
          !item.classList.contains("slide_clone"),
      )
      .sort((a, b) => (a.dataset.order || 0) - (b.dataset.order || 0));
  }

  function loadOverlayItem(cell) {
    // a looping slider's copies stand in for their real slide
    if (cell.sliderOriginal) {
      cell = cell.sliderOriginal;
    }

    overlayCell = cell;

    let id = cell.getAttribute("data-id");
    let catid = cell.getAttribute("data-catid") || "";
    let nextIds = overlayNextCells(cell, 2)
      .map((next) => next.getAttribute("data-id"))
      .join(",");

    // a hash link to an item off the page only has its slug
    let url =
      id != null
        ? "/getItem.php?id=" + id + "&catid=" + catid
        : "/getItem.php?slug=" +
          encodeURIComponent(cell.getAttribute("data-slug"));
    if (nextIds != "") {
      url += "&next=" + encodeURIComponent(nextIds);
    }

    setOverlayHash(cellHashKey(cell));

    getAjax(url, function (data) {
      overlayInner.innerHTML = data;
      // a card further down opens its item back at the top
      overlayInner.scrollTop = 0;
      fullVideoInit(overlayInner);
      overlayAutoVideoInit();
      overlayNavUpdate();
      openOverlay();
    });
  }

  // the next-video cards' preview loops play in view like the grids' do. One
  // instance for the overlay - update() picks up each new item's cards
  let overlayAutoVideos = null;

  function overlayAutoVideoInit() {
    if (overlayAutoVideos == null) {
      overlayAutoVideos = new LazyLoad({
        elements_selector: "#overlay .autovideo",
        threshold: 30,
        callback_enter: playAutoVideo,
        callback_exit: pauseAutoVideo,
      });
    } else {
      overlayAutoVideos.update();
    }
  }

  // the cells after this one, wrapping - they fill the "next videos" cards
  // under the player
  function overlayNextCells(cell, count) {
    let cells = overlaySiblings(cell);
    let current = cells.indexOf(cell);
    let next = [];
    if (current < 0) {
      return next;
    }
    for (let i = 1; i < cells.length && next.length < count; i++) {
      next.push(cells[(current + i) % cells.length]);
    }
    return next;
  }

  // one grid, one item: nothing to step through
  function overlayNavUpdate() {
    let navs = overlay.querySelectorAll(".overlayNav");
    if (!navs.length) {
      return;
    }

    // a cell made up for a hash link isn't in any grid
    let stepable =
      overlayCell != null &&
      overlayCell.isConnected &&
      overlaySiblings(overlayCell).length > 1;

    navs.forEach((nav) => {
      nav.classList.toggle("on", stepable);
    });
  }

  function overlayStep(direction) {
    if (overlayCell == null) {
      return;
    }

    let cells = overlaySiblings(overlayCell);
    let current = cells.indexOf(overlayCell);
    if (current < 0 || cells.length < 2) {
      return;
    }

    // wraps, so neither arrow is ever a dead end
    let next = (current + direction + cells.length) % cells.length;
    loadOverlayItem(cells[next]);
  }

  function overlayNavInit() {
    if (typeof overlay == "undefined" || overlay == null) {
      return;
    }

    let prev = overlay.querySelector(".overlayNav.prev");
    let next = overlay.querySelector(".overlayNav.next");
    if (prev == null || next == null) {
      return;
    }

    prev.addEventListener("click", function (e) {
      e.preventDefault();
      overlayStep(-1);
    });

    next.addEventListener("click", function (e) {
      e.preventDefault();
      overlayStep(1);
    });

    document.addEventListener("keydown", function (event) {
      if (!overlay.classList.contains("on")) {
        return;
      }
      if (event.key === "ArrowLeft") {
        overlayStep(-1);
      } else if (event.key === "ArrowRight") {
        overlayStep(1);
      }
    });
  }

  // clicks inside whatever getItem.php loaded: a next-video card opens that
  // item, "more info" scrolls down to the project write-up
  function overlayContentInit() {
    if (typeof overlay == "undefined" || overlay == null) {
      return;
    }

    overlayInner.addEventListener("click", function (e) {
      let card = e.target.closest(".nextVideo");
      if (card != null) {
        e.preventDefault();
        if (overlayCell == null) {
          return;
        }
        let cell = overlaySiblings(overlayCell).find(
          (sibling) =>
            sibling.getAttribute("data-id") === card.getAttribute("data-id"),
        );
        if (cell) {
          loadOverlayItem(cell);
        }
        return;
      }

      let more = e.target.closest(".moreInfo");
      if (more != null) {
        e.preventDefault();
        let text = overlayInner.querySelector(".projectText");
        if (text != null) {
          overlayInner.scrollTo({
            top: text.offsetTop - 80,
            behavior: prefersReducedMotion ? "auto" : "smooth",
          });
        }
      }
    });
  }

  /* FULL VIDEO PLAYER - custom controls for the MP4s getItem.php serves */

  // the player in the overlay, when the item showing is an MP4
  let fullVideo = null;

  function fullVideoToggle(video) {
    if (video.paused || video.ended) {
      // play() rejects if the browser blocks it - the icon just stays on play
      video.play().catch(function () {});
    } else {
      video.pause();
    }
  }

  function fullVideoInit(root) {
    fullVideo = root.querySelector(".fullVideo");
    if (fullVideo == null) {
      return;
    }

    let player = fullVideo;
    let video = player.querySelector("video");
    let toggleBtn = player.querySelector(".toggle");
    let progress = player.querySelector(".progress");
    let track = player.querySelector(".track");
    let muteBtn = player.querySelector(".mute");
    let fullscreenBtn = player.querySelector(".fullscreen");

    // the markup ships with native controls as a no-JS fallback
    video.controls = false;

    let frame = null;
    let idleTimer = null;
    let scrubbing = false;

    function setProgress(pct) {
      if (pct == null) {
        pct = video.duration ? video.currentTime / video.duration : 0;
      }
      player.style.setProperty("--progress", pct);
      progress.setAttribute("aria-valuenow", Math.round(pct * 100));
    }

    // timeupdate only fires a few times a second - redraw every frame instead
    function tick() {
      if (!scrubbing) {
        setProgress();
      }
      frame = requestAnimationFrame(tick);
    }

    // bar shows on any movement, then fades after a moment of stillness -
    // but only while playing, a paused video keeps its controls up
    function wake() {
      player.classList.remove("idle");
      clearTimeout(idleTimer);
      if (!video.paused) {
        idleTimer = setTimeout(function () {
          player.classList.add("idle");
        }, 2500);
      }
    }

    function onPlay() {
      player.classList.remove("paused");
      toggleBtn.setAttribute("aria-label", "Pause");
      cancelAnimationFrame(frame);
      tick();
      wake();
    }

    function onPause() {
      player.classList.add("paused");
      toggleBtn.setAttribute("aria-label", "Play");
      cancelAnimationFrame(frame);
      setProgress();
      wake();
    }

    function setRatio() {
      if (video.videoWidth && video.videoHeight) {
        player.style.setProperty("--ar", video.videoWidth / video.videoHeight);
      }
      setProgress();
    }

    video.addEventListener("play", onPlay);
    video.addEventListener("pause", onPause);
    video.addEventListener("ended", onPause);
    video.addEventListener("timeupdate", function () {
      if (video.paused && !scrubbing) {
        setProgress();
      }
    });
    video.addEventListener("loadedmetadata", setRatio);
    if (video.readyState >= 1) {
      setRatio();
    }

    video.addEventListener("volumechange", function () {
      player.classList.toggle("muted", video.muted);
      muteBtn.setAttribute("aria-label", video.muted ? "Unmute" : "Mute");
    });

    video.addEventListener("click", function () {
      fullVideoToggle(video);
    });

    toggleBtn.addEventListener("click", function () {
      fullVideoToggle(video);
    });

    muteBtn.addEventListener("click", function () {
      video.muted = !video.muted;
    });

    // a mouse click shouldn't leave focus on a button, or the next spacebar
    // press would click it again instead of playing / pausing
    player.querySelectorAll("button").forEach(function (btn) {
      btn.addEventListener("mousedown", function (e) {
        e.preventDefault();
      });
    });

    // scrubbing - click or drag anywhere along the bar
    function seekTo(e) {
      let rect = track.getBoundingClientRect();
      let pct = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
      setProgress(pct);
      if (video.duration) {
        video.currentTime = pct * video.duration;
      }
    }

    progress.addEventListener("pointerdown", function (e) {
      if (e.button !== 0) {
        return;
      }
      scrubbing = true;
      progress.setPointerCapture(e.pointerId);
      seekTo(e);
    });

    progress.addEventListener("pointermove", function (e) {
      if (scrubbing) {
        seekTo(e);
      }
    });

    function endScrub() {
      scrubbing = false;
    }
    progress.addEventListener("pointerup", endScrub);
    progress.addEventListener("pointercancel", endScrub);

    // arrows seek while the bar has focus - kept from reaching the overlay's
    // own arrow keys, which step to the next item
    progress.addEventListener("keydown", function (e) {
      if (!video.duration) {
        return;
      }
      let time = null;
      if (e.key === "ArrowLeft") {
        time = video.currentTime - 5;
      } else if (e.key === "ArrowRight") {
        time = video.currentTime + 5;
      } else if (e.key === "Home") {
        time = 0;
      } else if (e.key === "End") {
        time = video.duration;
      }
      if (time == null) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      video.currentTime = Math.min(Math.max(time, 0), video.duration);
      setProgress();
    });

    // fullscreen the whole player so the custom bar comes along - iPhone only
    // fullscreens a bare video, so it gets the native player there
    function fullscreenEl() {
      return document.fullscreenElement || document.webkitFullscreenElement;
    }

    fullscreenBtn.addEventListener("click", function () {
      if (fullscreenEl() === player) {
        (document.exitFullscreen || document.webkitExitFullscreen).call(
          document,
        );
      } else if (player.requestFullscreen) {
        player.requestFullscreen();
      } else if (player.webkitRequestFullscreen) {
        player.webkitRequestFullscreen();
      } else if (video.webkitEnterFullscreen) {
        video.webkitEnterFullscreen();
      }
    });

    function onFullscreenChange() {
      let isFullscreen = fullscreenEl() === player;
      player.classList.toggle("isFullscreen", isFullscreen);
      fullscreenBtn.setAttribute(
        "aria-label",
        isFullscreen ? "Exit full screen" : "Full screen",
      );
    }
    player.addEventListener("fullscreenchange", onFullscreenChange);
    player.addEventListener("webkitfullscreenchange", onFullscreenChange);

    player.addEventListener("pointermove", wake);
    player.addEventListener("pointerdown", wake);
    player.addEventListener("focusin", wake);
    player.addEventListener("mouseleave", function () {
      if (!video.paused) {
        clearTimeout(idleTimer);
        player.classList.add("idle");
      }
    });

    // it was opened from its thumbnail, so start right away. The click is
    // spent by the time the AJAX lands, and some browsers (Safari) then refuse
    // sound - start muted instead and let the mute button bring it back
    video.play().catch(function (err) {
      if (err.name !== "NotAllowedError") {
        return;
      }
      video.muted = true;
      video.play().catch(function () {});
    });
  }

  // spacebar plays / pauses whatever full video the overlay is showing
  function fullVideoKeysInit() {
    document.addEventListener("keydown", function (e) {
      if (e.key !== " " || e.repeat) {
        return;
      }
      if (
        fullVideo == null ||
        !fullVideo.isConnected ||
        !overlay.classList.contains("on")
      ) {
        return;
      }
      // leave typing and focused buttons their own spacebar
      if (
        e.target.closest &&
        e.target.closest("input, textarea, select, button, [contenteditable]")
      ) {
        return;
      }
      e.preventDefault();
      fullVideoToggle(fullVideo.querySelector("video"));
    });
  }

  /* SEARCH OVERLAY - opens from the fixed search button on every page */

  function searchInit() {
    if (
      typeof searchOverlay == "undefined" ||
      searchOverlay == null ||
      typeof searchBtn == "undefined" ||
      searchBtn == null
    ) {
      return;
    }

    let form = searchOverlay.querySelector(".searchForm");
    let input = searchOverlay.querySelector("input[name='q']");
    let results = searchOverlay.querySelector(".results");
    let closer = searchOverlay.querySelector(".closeLabel");
    let clearBtn = searchOverlay.querySelector(".searchForm .clear");

    // back to the empty state, overlay still open
    function clearSearch() {
      searchOverlay.classList.remove("hasResults");
      results.innerHTML = "";
      input.value = "";
      //input.focus();
    }

    function openSearch() {
      // the menu shares the screen - close it first
      body.classList.remove("menuOn");
      if (menuBtn != null) {
        menuBtn.textContent = "MENU";
      }

      body.classList.add("overlayOn", "searchOn");
      searchOverlay.classList.add("on");
      input.focus();
    }

    function closeSearch() {
      searchOverlay.classList.remove("on");
      body.classList.remove("overlayOn", "searchOn");
      // next open starts fresh, back in the empty state
      clearSearch();
    }

    searchBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (searchOverlay.classList.contains("on")) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    closer.addEventListener("click", function (e) {
      e.preventDefault();
      closeSearch();
    });

    clearBtn.addEventListener("click", function (e) {
      e.preventDefault();
      clearSearch();
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && searchOverlay.classList.contains("on")) {
        closeSearch();
      }
    });

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      let term = input.value.trim();
      if (term === "") {
        return;
      }

      // phones keep the keyboard up while the field has focus, covering the
      // results - dropping focus closes it on both iOS and Android
      input.blur();

      results.innerHTML = "";
      searchOverlay.classList.add("searching");

      getAjax("/search.php?q=" + encodeURIComponent(term), function (data) {
        searchOverlay.classList.remove("searching");
        results.innerHTML = data;
        // pull the column up out of its empty-state position, and show the
        // results from the top however far down the last search was scrolled
        searchOverlay.classList.add("hasResults");
        results.scrollTop = 0;
        // results are cells like the editor grid: lazyload their stills and
        // hover loops, and wire them into the video overlay
        loadInit();
        overlayLinksInit(results);
      });
    });
  }

  /* COLOR THEME - the eye in the bottom-right corner swaps the tan paper for
     the dark one. The choice is remembered per visitor; topScripts.php applies
     it to <html> before first paint. */

  function colorThemeInit() {
    let eyeBtn = document.querySelector(".fixed_eyeBtn");
    if (typeof eyeBtn == "undefined" || eyeBtn == null) {
      return;
    }

    eyeBtn.setAttribute(
      "aria-pressed",
      document.documentElement.classList.contains("dark_theme")
        ? "true"
        : "false",
    );

    eyeBtn.addEventListener("click", function (e) {
      e.preventDefault();

      let isDark = document.documentElement.classList.toggle("dark_theme");
      eyeBtn.setAttribute("aria-pressed", isDark ? "true" : "false");

      // private windows and blocked site data throw here - the toggle still
      // works, it just won't be remembered
      try {
        localStorage.setItem("papercutTheme", isDark ? "dark" : "light");
      } catch (err) {}
    });
  }

  // the eye sits over the footer's social icons, so get it out of the way
  // while any part of the footer is in the viewport
  function eyeFooterFadeInit() {
    let eyeBtn = document.querySelector(".fixed_eyeBtn");
    let footer = document.querySelector("footer");
    if (!eyeBtn || !footer) {
      return;
    }

    ScrollTrigger.create({
      trigger: footer,
      start: "top bottom",
      end: "bottom top",
      toggleClass: { targets: eyeBtn, className: "footer_in_view" },
    });
  }

  // phones show the full logo at the top of the page - once scrolled, the
  // header swaps it for the mark (the styles only act on this under 768px)
  function headerLogoScrollInit() {
    let logo = document.querySelector(".fixed_logo");
    if (!logo) {
      return;
    }

    ScrollTrigger.create({
      start: 40,
      end: "max",
      toggleClass: { targets: logo, className: "scrolled" },
    });
  }

  function backgroundParallaxInit() {
    let bgItems = document.querySelectorAll(".background img");
    if (!bgItems.length) {
      return;
    }

    bgItems.forEach((item) => {
      let speed = parseFloat(item.getAttribute("data-speed")) || 0.3;

      gsap.to(item, {
        y: () => -(document.body.scrollHeight - window.innerHeight) * speed,
        ease: "none",
        scrollTrigger: {
          trigger: document.body,
          start: "top top",
          end: "bottom bottom",
          scrub: true,
        },
      });
    });
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {}

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */

  // bio links
  let overlayBioLinks = document.querySelectorAll(".openBio");
  overlayBioLinks.forEach((overlayLink) => {
    overlayLink.addEventListener("click", function (e) {
      e.preventDefault();
      let id = overlayLink.getAttribute("data-id");
      getAjax("/getBio.php?id=" + id, function (data) {
        overlayInner.innerHTML = data;
        overlayCell = null;
        overlayNavUpdate();
        openOverlay();
      });
    });
  });

  // overlay links - also called on markup injected by the search
  function overlayLinksInit(root) {
    let overlayLinks = (root || document).querySelectorAll(".openOverlay");
    overlayLinks.forEach((overlayLink) => {
      if (overlayLink.dataset.overlayBound === "yes") {
        return;
      }
      overlayLink.dataset.overlayBound = "yes";
      overlayLink.addEventListener("click", function (e) {
        e.preventDefault();
        loadOverlayItem(overlayLink);
      });
    });
  }

  overlayLinksInit();

  overlayNavInit();

  overlayContentInit();

  overlayHashOpen();
  window.addEventListener("hashchange", overlayHashOpen);

  if (typeof overlay != "undefined" && overlay != null) {
    fullVideoKeysInit();
  }

  searchInit();

  //hamburger menu toggle
  if (typeof menuBtn != "undefined" && menuBtn != null) {
    menuBtn.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        let isOpen = document.body.classList.toggle("menuOn");
        menuBtn.textContent = isOpen ? "CLOSE" : "MENU";
      },
      true,
    );
  }

  // close overlay
  if (typeof overlay != "undefined" && overlay != null) {
    overlayCloser.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        closeOverlay();
      },
      true,
    );

    // close overlay on ESC key
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && overlay.classList.contains("on")) {
        closeOverlay();
      }
    });
  }

  // start push state functions

  // Handle browser back/forward buttons
  window.addEventListener("popstate", async (event) => {
    const url = window.location.pathname;
    await loadContent(url);
  });

  const pageCache = new Map();
  const CACHE_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes in milliseconds

  function pushStateInit() {
    // top level pages
    let pushStateLinks = document.querySelectorAll(".pushstate");
    if (typeof pushStateLinks != "undefined" && pushStateLinks != null) {
      pushStateLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          let url = link.getAttribute("href");
          loadContent(url);
          closeOverlay();
        });
      });
    }
  }

  pushStateInit();

  async function loadContent(url) {
    // Prevent loading if already in progress
    if (loadContent.isLoading) return;
    loadContent.isLoading = true;

    try {
      // apply any resets
      closeNav();

      const parentEl = document.querySelector("section#content");

      // Start loading content immediately
      const [content] = await Promise.all([
        (async () => {
          const cached = pageCache.get(url);
          const now = Date.now();
          if (cached && now - cached.timestamp < CACHE_EXPIRY_MS) {
            return Promise.resolve(cached.content);
          }
          const response = await fetch(`/content.php?page=${url}`);
          if (!response.ok)
            throw new Error(`HTTP error! status: ${response.status}`);
          const text = await response.text();
          pageCache.set(url, { content: text, timestamp: now });
          return text;
        })(),
        gsap
          .to(parentEl, {
            opacity: 0,
            duration: 0.3,
            ease: "power1.out",
          })
          .then(),
      ]);

      body.classList.remove(
        "projectpage",
        "textpage",
        "homepage",
        "intro_playing",
      );

      // Update content and fade in
      parentEl.innerHTML = content;

      // register data-speed / data-lag parallax on the freshly injected content
      if (smoother) {
        smoother.effects(
          parentEl.querySelectorAll("[data-speed], [data-lag]"),
          {},
        );
      }

      // general functions
      loadInit();
      animationInit();
      pushStateInit();
      playFullVideoInit();
      gridTitleAnimation();
      editorsHoverInit();
      //bioRevealInit();
      staggeredRowsRevealInit();

      // colect page specific vars
      let newContentEl = parentEl.querySelector("article.inner");
      let newBodyClass = newContentEl.getAttribute("data-bodyclass");
      let bgColor = newContentEl.getAttribute("data-bgcolor");
      let primaryColor = newContentEl.getAttribute("data-primarycolor");

      // apply updated body vars
      document.body.style.backgroundColor = bgColor;
      document.body.style.color = primaryColor;

      if (newBodyClass != "") {
        body.classList.add(...newBodyClass.split(" ")); // Add new classes while keeping existing ones
      }

      // page specific functions
      let arRowsEl = newContentEl.querySelector(".ar-rows");
      if (typeof arRowsEl != "undefined" && arRowsEl != null) {
        let arRowsEls = newContentEl.querySelectorAll(".ar-rows");
        arRows(arRowsEls);
        arRowsReveal();
      }

      let masonGrids = newContentEl.querySelector(".masongrid");
      if (typeof masonGrids != "undefined" && masonGrids != null) {
        W;
        masonryInit();
      }

      let marqueeCheck = newContentEl.querySelector(".marquee .carousel");
      if (typeof marqueeCheck != "undefined" && marqueeCheck != null) {
        marqueeInits();
      }

      let textPageCheck = parentEl.querySelector(".textpage");
      if (typeof textPageCheck != "undefined" && textPageCheck != null) {
        textPageAnimation();
      }

      let projectPageCheck = parentEl.querySelector(".modules");
      if (typeof projectPageCheck != "undefined" && projectPageCheck != null) {
        projectSidebarsInit();
        projectDetailAnimation();
      }

      let homepageCheck = parentEl.querySelector(".home");
      if (typeof homepageCheck != "undefined" && homepageCheck != null) {
        gsap.set(headerLogo, { opacity: 0 });
        homepageInit();
      } else {
        // make sure logo is visible, may need to do a check for homepage here
        gsap.set(headerLogo, { opacity: 1 });
      }

      gsap.to(parentEl, {
        opacity: 1,
        duration: 0.5,
      });

      // Update history
      history.pushState(null, null, url);

      // scroll to top of page + recalc scroll positions for the new content
      if (smoother) {
        smoother.paused(false);
        smoother.scrollTo(0, false);
        // full-viewport layouts rely on position: fixed, which breaks inside
        // the transformed #smooth-content – pause smoothing on those
        let fixedLayout = parentEl.querySelector(".editors_wrap, .two_column");
        smoother.paused(!!fixedLayout);
        ScrollTrigger.refresh();
      } else {
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, 100);
      }

      return content;
    } catch (error) {
      console.error("Failed to load content:", error);
      // Fade back in if there's an error
      const parentEl = document.querySelector("section#content");
      gsap.to(parentEl, { opacity: 1, duration: 0.5 });
    } finally {
      loadContent.isLoading = false;
    }
  }
});
